import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';

import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from 'reactstrap';
import { Pagination } from 'rsuite';
import 'rsuite/dist/styles/rsuite-default.css'
import './users.scss'
import { userProfileService } from '../../services/backoffice/userProfile.service'
import moment from 'moment';
import { CSVExporterTypes } from '../../enums/CSVExporterTypes'

const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2
    }).format(amount ?? 0);
};
export function Users() {
    const [tableData, setTableData] = useState({ list: [], totalPages: 1, totalCount: 0, pageIndex: 1, filterBy: "", filter: "", orderBy: "EmployeeNo", ascending: false });
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen(prevState => !prevState);

    useEffect(() => {
        getUsers(1, tableData.filterBy, tableData.filter, tableData.orderBy, tableData.ascending);
    }, []);

    const getUsers = (pageIndex, filterBy, filter, orderBy, ascending) => {
        userProfileService.getAll(pageIndex, 20, filterBy, filter, orderBy, ascending).
            then((result) => {
                if (result.list.length > 0)
                    setTableData({ list: result.list, totalPages: result.totalPages, totalCount: result.totalCount, pageIndex, filterBy, filter, orderBy, ascending });
            });
    }

    const handleSelectPage = (pageIndex) => {
        getUsers(pageIndex, tableData.filterBy, tableData.filter, tableData.orderBy, tableData.ascending);
    }

    const handleFind = () => {
        const filterBy = tableData.filter == "" ? "" : "Name";
        getUsers(tableData.pageIndex, filterBy, tableData.filter, tableData.orderBy, tableData.ascending);
    }

    const handleOrdering = (orderBy) => {
        const ascending = orderBy == tableData.orderBy ? !tableData.ascending : false;
        getUsers(tableData.pageIndex, tableData.filterBy, tableData.filter, orderBy, ascending);
    }

    const handleCsv = (orderBy) => {
        const ascending = orderBy == tableData.orderBy ? !tableData.ascending : false;
        userProfileService.downloadUsersCSV(orderBy, CSVExporterTypes.USERS, ascending);
    }

    return (
        <section className="wrapper_users padd">
            <div className="mb-4 divtop">
                <div className="box_ttl_opt">
                    <h2 className="mb-0 text fnt_medium">Usuarios</h2>
                    <div className="box_actions">
                        <button className="btn secundary mr-2" onClick={() => handleCsv("EmployeeNo")}>
                            <i className="far fa-file-excel"></i>
                            Exportar <span>usuarios</span>
                        </button>
                        <ButtonDropdown isOpen={dropdownOpen} toggle={toggle} className="dropdown-custom">
                            <DropdownToggle className="btn primary" caret>
                                <i className="fas fa-user-plus" aria-hidden="true" title="Cargar usuarios"></i> Cargar <span>usuarios</span>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-left">
                                <DropdownItem tag={Link} to="/users-details/new">
                                    <i className="far fa-user" aria-hidden="true" title="Carga individual"></i> Carga individual
                                </DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem tag={Link} to="/bulk-load">
                                    <i className="fas fa-users" aria-hidden="true" title="Carga masiva"></i> Carga masiva
                                </DropdownItem>
                            </DropdownMenu>
                        </ButtonDropdown>
                    </div>
                </div>
            </div>
            <div className="card shadows p-3 box_tool_user">
                <div className="row  align-items-center">
                    <div className="col-sm-8">
                        <h6 className="mb-0">Total de usuarios: <span className="text fnt_medium">{tableData.totalCount}</span></h6>
                    </div>
                    <div className="col-sm-4">
                        <form className="form_inline" onSubmit={(e) => { e.preventDefault(); handleFind(); }}>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Buscar por nombre"
                                value={tableData.filter}
                                onChange={(e) => setTableData({ ...tableData, filter: e.target.value })}
                            />
                            <div className="box_search_inp">
                                <button type="submit" className="btn">
                                    <i className="fas fa-search"></i>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className=" table-responsive card shadows p-3 mt-4">
                <table className="wrapper_table table table-hover table-lg">
                    <thead>
                        <tr>
                            <th className="text fnt_medium" onClick={() => handleOrdering("EmployeeNo")}>
                                No. Empleado
                                 {tableData.orderBy == "EmployeeNo" && <i class={`fas fa-sort-${tableData.ascending ? 'up' : 'down'}`}></i>}
                            </th>
                            <th className="text fnt_medium col-name" onClick={() => handleOrdering("Name")}>
                                Nombre completo
                                {tableData.orderBy == "Name" && <i className={`fas fa-sort-${tableData.ascending ? 'up' : 'down'}`}></i>}
                            </th>
                            <th className="text fnt_medium" onClick={() => handleOrdering("Gender")}>
                                Género
                                 {tableData.orderBy == "Gender" && <i class={`fas fa-sort-${tableData.ascending ? 'up' : 'down'}`}></i>}
                            </th>
                            <th className="text fnt_medium text-center" onClick={() => handleOrdering("Age")}>
                                Edad
                                 {tableData.orderBy == "Age" && <i class={`fas fa-sort-${tableData.ascending ? 'down' : 'up'}`}></i>}
                            </th>
                            <th className="text fnt_medium " onClick={() => handleOrdering("Seniority")}>
                                Antigüedad
                                 {tableData.orderBy == "Seniority" && <i class={`fas fa-sort-${tableData.ascending ? 'down' : 'up'}`}></i>}
                            </th>
                            <th className="text fnt_medium" onClick={() => handleOrdering("BranchOffice")}>
                                Sucursal
                                 {tableData.orderBy == "BranchOffice" && <i class={`fas fa-sort-${tableData.ascending ? 'up' : 'down'}`}></i>}
                            </th>
                            <th className="text fnt_medium" onClick={() => handleOrdering("Department")}>
                                Departamento
                                 {tableData.orderBy == "Department" && <i class={`fas fa-sort-${tableData.ascending ? 'up' : 'down'}`}></i>}
                            </th>
                            <th className="text fnt_medium" onClick={() => handleOrdering("JobRole")}>
                                Puesto
                                 {tableData.orderBy == "JobRole" && <i class={`fas fa-sort-${tableData.ascending ? 'up' : 'down'}`}></i>}
                            </th>
                            <th className="text fnt_medium text-right">Saldo Crédito</th>
                            <th className="text fnt_medium text-right">Saldo Prepago</th>
                            <th className="text fnt_medium text-right">Saldo Total</th>
                            <th className="text fnt_medium text-center">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            tableData.list.map(user =>
                                <tr>
                                    <td><Link to={"/users-details/" + user.aspNetUserId} className="link_data">{user.employeeNo}</Link></td>
                                    <td className="col-name">
                                        <Link to={`/users-details/${user.aspNetUserId}`} className="link_data">{user.name}</Link>
                                    </td>                                    <td>{user.gender}</td>
                                    <td className="text-center">{moment().diff(user.birthday, 'years')}</td>
                                    <td >{user.seniority}</td>
                                    <td>{user.branchOfficeName}</td>
                                    <td>{user.departmentName}</td>
                                    <td>{user.jobRoleName}</td>
                                    <td className="text-right">{formatCurrency(user.creditBalance)}</td>
                                    <td className="text-right">{formatCurrency(user.prepaidBalance)}</td>
                                    <td className="text-right">{formatCurrency(user.totalBalance)}</td>
                                    <td className="text-center"><span className={`text-${user.active ? 'success' : 'danger'} text fnt_medium`}>{user.active ? "Activo" : "Inactivo"}</span></td>
                                </tr>)
                        }
                    </tbody>
                </table>
                <Pagination prev last next first size="lg" ellipsis maxButtons={10} boundaryLinks pages={tableData.totalPages} activePage={tableData.pageIndex} onSelect={handleSelectPage} />
            </div>
        </section>
    )
}